var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-container"},[_c('p',[_vm._v("Copyright ©2020 Social Area Networks Co.,Ltd. All rights reserved.")])])}]

export { render, staticRenderFns }